import { useState } from 'react';
import {
  FilterSection,
  FilterSectionBody,
  FilterSectionChevron,
  FilterSectionToggle
} from './styles/filterPanel.styles';

type CollapsibleSectionProps = {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
};

const CollapsibleSection = ({ title, children, defaultOpen = true }: CollapsibleSectionProps) => {
  const [collapsed, setCollapsed] = useState(!defaultOpen);

  return (
    <FilterSection data-collapsed={collapsed ? 'true' : 'false'}>
      <FilterSectionToggle type="button" onClick={() => setCollapsed(prev => !prev)}>
        {title}
        <FilterSectionChevron>&#x25BC;</FilterSectionChevron>
      </FilterSectionToggle>
      <FilterSectionBody>{children}</FilterSectionBody>
    </FilterSection>
  );
};

export default CollapsibleSection;
